<div class="user-management-container" style="margin-top: 90px;"
     [class.sidebar-expanded]="sidebarExpanded || isStandaloneMode"
     [class.sidebar-collapsed]="!sidebarExpanded && !isStandaloneMode"
     [class.skip-transition]="skipTransition">
  <div class="user-management-menu hpanel p-0 sticky-side-menu">
    <div class="panel-body p-0 b-r-6">
      <!-- Sidebar Title with Toggle — only for the full business Admin Center.
           The standalone Job Center / Talent Center / Talent Pools view shows
           just its 3 menu items with no "Admin Center" header. -->
      <div class="sidebar-title-row" *ngIf="!isStandaloneMode">
        <span class="sidebar-title">Admin Center</span>
        <div class="sidebar-toggle-btn" (click)="toggleSidebar()" [title]="sidebarExpanded ? 'Collapse menu' : 'Expand menu'">
          <ng-icon [name]="sidebarExpanded ? 'tablerChevronLeft' : 'tablerChevronRight'"></ng-icon>
        </div>
      </div>
      <ul class="custom-panel pad">
        <ng-container *ngFor="let item of navBarList">
          <!-- Regular Menu Item -->
          <li class="navmenu nav-display" title="{{item.name}}" (click)="routeTo(item.item)" [routerLink]="item?.path"
            [queryParams]="isFreeOrTeam ? businessData : null" [ngClass]="{'active': isActive(item)}">
            <!-- Tabler icons — each uses `fill="currentColor"`, so the hover
                 / active colour cascade from `.navmenu` tints them reliably. -->
            <ng-icon name="tablerBuilding" *ngIf="item.item === 'company'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerCrown" *ngIf="item.item === 'plan'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerNetwork" *ngIf="item.item === 'network'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerChartBar" *ngIf="item.item === 'analytics'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerHandClick" *ngIf="item.item === 'interaction'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerId" *ngIf="item.item === 'businessContacts'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerId" *ngIf="item.item === 'contacts'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerSitemap" *ngIf="item.item === 'businessNetworks'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerBriefcase" *ngIf="item.item === 'jobs'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerLayoutGrid" *ngIf="item.item === 'workSpace'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerUsers" *ngIf="item.item === 'user'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerFileInvoice" *ngIf="item.item === 'billing'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerBell" *ngIf="item.item === 'notification'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerCreditCard" *ngIf="item.item === 'credit'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerShare" *ngIf="item.item === 'referral'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerSettings" *ngIf="item.item === 'settings'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerLock" *ngIf="item.item === 'appAccess'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerBriefcase" *ngIf="item.item === 'businessJob'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerUserCheck" *ngIf="item.item === 'businessCandidate'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>
            <ng-icon name="tablerUserPlus" *ngIf="item.item === 'businessApplicants'" class="svg-position" style="font-size:24px;width:28px;height:28px;min-width:28px"></ng-icon>

            <!-- Menu text -->
            <a class="letter-spacing-0" style="white-space:nowrap">{{item?.name}}</a>
          </li>
        </ng-container>
      </ul>

    </div>
  </div>
  <div class="user-management-content">
    <!-- Module Title - Removed, now shown in sidebar title -->
    <!-- <div class="module-title-header">
      <span class="module-context">Admin</span>
    </div> -->

    <!-- Company Horizontal Sub-Menu -->
    <!-- Uses visibleCompanySubMenus to filter tabs based on user permissions -->
    <div class="company-horizontal-menu" *ngIf="isCompanyRoute()">
      <ul class="company-sub-tabs">
        <li *ngFor="let subMenu of visibleCompanySubMenus"
            [routerLink]="subMenu.path"
            [queryParams]="isFreeOrTeam ? businessData : null"
            [ngClass]="{'active': isCompanySubMenuActive(subMenu)}">
          <ng-icon [name]="subMenu.item === 'company-profile' ? 'tablerBuildingSkyscraper' :
                                        subMenu.item === 'company-services' ? 'tablerLayoutGrid' :
                                        subMenu.item === 'company-portfolio' ? 'tablerBriefcase' :
                                        subMenu.item === 'company-contacts' ? 'tablerId' : 'tablerCash'" class="sub-tab-icon"></ng-icon>
          <span>{{ subMenu.name }}</span>
        </li>
      </ul>
    </div>

    <div class="hpanel" *ngIf="showSearchBar()">
      <app-admin-hor-menu *ngIf="showNavbar()" [businessData]="businessData"></app-admin-hor-menu>
      <!-- <hr class="customerhrtag"> -->
      <div class="panel-body b-r-6 customer-header-setup">
        <div class="col-sm-6 mr-bt-20" >
          <!-- Show business info if business data exists -->
          <h5 class="fw-bold" *ngIf="hasBusinessData() && showSearchBar()">
            <span *ngIf="businessData?.businessName!='null'&&businessData?.businessName!='undefined'">
              {{businessData?.businessName }}
            </span>
            <span *ngIf="businessData?.bid">({{businessData?.bid }})</span>
            <span *ngIf="businessData?.plan">
              ({{businessData?.plan}})
            </span>
          </h5>
          <!-- Show user info if no business data exists -->
          <h5 class="fw-bold" *ngIf="!hasBusinessData() && showSearchBar()">
            <span *ngIf="userGigsumoId">({{userGigsumoId}})</span>
            <span *ngIf="userPlan">({{userPlan}})</span>
          </h5>
        </div>
        <div class="col-sm-6" *ngIf="!isStandaloneMode && activeScreen !== 'BUSINESS-JOBS' && activeScreen !== 'BUSINESS-CANDIDATES' && activeScreen !== 'BUSINESS-APPLICANTS'">
          <div class="flex-end-gap" style="align-items: center;">
            <ng-container *ngIf="checkHigherPlanFeatures()">
              <ng-container *ngIf="activeScreen === 'CONTACT'">
                <button (click)="openModalContact()" type="button" class="btn btn-primary w-nowrap ">Add
                  Members</button>
              </ng-container>
              <ng-container *ngIf="activeScreen === 'NETWORK'">
                <button (click)="openModalContact()" type="button" class="btn btn-primary w-nowrap ">
                 Add Network</button>
              </ng-container>
              <ng-container *ngIf="activeScreen === 'USER'">
                <button (click)="openAddUserModal()" type="button" class="btn btn-primary w-nowrap">Add
                  Users</button>
              </ng-container>
              <ng-container *ngIf="activeScreen === 'B2BCONTACTS'">
                <button (click)="openModalContact()" type="button" class="btn btn-primary w-nowrap"><ng-icon name="tablerPlus" class="plus mr-1"></ng-icon>Add Business</button>
              </ng-container>
              <ng-container *ngIf="activeScreen === 'B2BNETWORKS'">
                <button (click)="openModalContact()" type="button" class="btn btn-primary w-nowrap"><ng-icon name="tablerPlus" class="plus mr-1"></ng-icon> Add
                  Network</button>
              </ng-container>

              <ng-container
                *ngIf="activeScreen != 'TOPUP' && activeScreen != 'BUSINESS-APPLICANTS' && activeScreen != 'BUSINESS-CANDIDATES' && activeScreen != 'BUSINESS-JOBS' && activeScreen != 'PUBLISH-SETTINGS'">
                <button class="btn btn-primary w-nowrap" (click)="openModalUsingComponent(manageButton)">
                  {{manageButton}} </button>
              </ng-container>
              <ng-container *ngIf="activeScreen === 'WORKSPACE'">
                <button (click)="openModalUsingComponent('Manage Workspaces')" type="button"
                  class="btn  btn-primary w-nowrap">Manage
                  Workspaces</button>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="checkDowngradeOrUpgradeOptions() && activeScreen === 'TOPUP'">
              <button *ngIf="MemberShipType!='ScaleX'" class="btn btn-primary"
                [routerLink]="['/plan-quota']">
                Upgrade Plan</button>

              <button *ngIf="downgradeRequested" type="button" (click)="apiCancelDowngrade()"
                class="btn btn-primary">
                Cancel Downgrade
              </button>
            </ng-container>

            <ng-container *ngIf="checkEnterprisePlan() && activeScreen === 'TOPUP'">
              <button type="button" (click)="openContactSales()" class="btn btn-danger   btn-plan-style">
                Downgrade Plan
              </button>
            </ng-container>

          </div>
        </div>
        <!-- <div *ngIf="showSearchBar() && activeScreen != 'TOPUP'" class="col-sm-12">
            <div class="search-field-input">
              <span class="customer-search-svg-icon">
                <ng-icon name="tablerSearch"></ng-icon>
              </span>
              <input [(ngModel)]="searchText" (keyup)="onSearch()" type="text" [placeholder]="placeHolderText"
                class="searchBox form-control">
            </div>
          </div> -->
      </div>
    </div>
    <router-outlet (activate)="onActivate($event)" (deactivate)="componentRemoved($event)"></router-outlet>
  </div>
</div>
<ng-template #upgradeModal let-modal>
  <div class="common-header-flex">
    <div>Upgrade Plan</div>
    <ng-icon name="tablerX" class="svg-position common-close" style="padding: 0px; text-align: left" (click)="closeModal()"></ng-icon>
  </div>
  <div class="modal-body">
    <form>
      <div class="col-12">
        <div class="row">
          <div class="col-md-2 m-b">
            <label for="gigsumoId">Gigsumo ID</label>
          </div>
          <div class="col-md-4 m-b">
            <input class="form-control" id="gigsumoId" type="text">
          </div>
          <div class="col-md-2 m-b">
            <label for="effectiveDate">Effective Date</label>

          </div>
          <div class="col-md-4 m-b">
            <input class="form-control" id="effectiveDate" type="text" placeholder="mm/dd/yyyy">
          </div>
          <div class="col-md-2 m-b">
            <label for="planName">Name</label>
          </div>
          <div class="col-md-4 m-b">
            <input class="form-control" id="planName" type="text">

          </div>
          <div class="col-md-2 m-b">
            <label for="effectiveUntil">Effective Until</label>

          </div>
          <div class="col-md-4 m-b">
            <input class="form-control" id="effectiveUntil" type="text" placeholder="mm/dd/yyyy">

          </div>
          <div class="col-md-2 m-b">
            <label for="userType">User Type</label>

          </div>
          <div class="col-md-4 m-b">
            <input class="form-control" id="userType" type="text">
          </div>
          <div class="col-md-2 m-b">
            <label for="initialUsers">Initial Users</label>
          </div>
          <div class="col-md-4 m-b">
            <input class="form-control" id="initialUsers" type="text" value="10">
          </div>
          <div class="col-md-2 m-b">
            <label for="currentPlan">Current Plan</label>
          </div>
          <div class="col-md-4 m-b">
            <input class="form-control" id="currentPlan" type="text" value="Free">
          </div>
          <div class="col-md-2 m-b">
            <label for="newPlan">New Plan</label>
          </div>
          <div class="col-md-4 m-b">
            <input class="form-control" id="newPlan" type="text" value="Growth">
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row text-center">
          <div class="col-md-6">
            <label>Current In Plan</label>
          </div>
          <div class="col-md-3">
            <label>Available</label>
          </div>
          <div class="col-md-3">
            <label>New Plan</label>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-sm-2">
            <label for="jobSlots">Job/Candidates Slots</label>
          </div>
          <div class="col-sm-4">
            <input class="form-control" id="jobSlots" type="text">
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input class="form-control" type="text">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input class="form-control" type="text">
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="interactions">Interactions</label>

            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input class="form-control" id="interactions" type="text">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input class="form-control" type="text">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input class="form-control" type="text">
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="contacts">Contacts</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input class="form-control" id="contacts" type="text">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input class="form-control" type="text">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input class="form-control" type="text">
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="workspaces">Workspaces</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input class="form-control" id="workspaces" type="text">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input class="form-control" type="text">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input class="form-control" type="text">
            </div>
          </div>
          <div class="col-md-2">
            <label for="b2bNetworks">B2B Networks</label>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input class="form-control" id="b2bNetworks" type="text">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input class="form-control" type="text">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input class="form-control" type="text">
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn  btn-primary">Activate</button>
  </div>
</ng-template>
<ng-template #manageUserModal>
  <div class="common-header-flex">
    <div>Manage User</div>
    <ng-icon name="tablerX" class="svg-position common-close" (click)="closeModal()"></ng-icon>
  </div>

  <div class="modal-body">

    <div class="row">

      <div class="col-sm-12 col-md-12 col-lg-12" style="height: 300px;overflow: auto;">

        <ng-container>

          <table>
            <tr>
              <th>Gigsumo ID</th>
              <th>Name</th>
              <th>Email ID</th>
              <th>Role</th>
              <th>Status</th>
              <th>App Access</th>
            </tr>
            <ng-container *ngFor="let user of userData">
              <tr>
                <td>{{user?.gigsumoNo}}</td>
                <td>{{user?.fullName}}</td>
                <td>{{user?.email}}</td>
                <td>{{user?.userType | MTAPipe: 'convertMTA' | titlecase}}</td>
                <td>{{user?.userStatus}}</td>
                <td>
                  <label class="custom-switch">
                    <input type="checkbox" [(ngModel)]="user.appAccessEnabled" [ngModelOptions]="{standalone: true}">
                    <span class="custom-slider">
                      <span class="on">On</span>
                      <span class="off">Off</span>
                    </span>
                  </label>
                </td>
              </tr>
            </ng-container>

          </table>


        </ng-container>

      </div>


    </div>


  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default w70" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn  btn-primary w70"
      (click)="manageUsers()">Save</button>
  </div>

</ng-template>
<app-common-modal *ngIf="showModal" [openmodal]="openbusinessModal" [title]="selectedItem" [type]="'ADD'"
  (response)="closeModal($event)">
</app-common-modal>
